<template>
    <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
            <!-- Sidebar navigation-->
            <nav class="sidebar-nav">
                <ul id="sidebarnav">
                    <li>
                        <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                           aria-expanded="false">
                            <i class="fas fa-caret-square-right"></i>
                            <span class="hide-menu">Campaigns</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li>
                                <router-link :to="{name: 'pmtaCampaigns'}" active-class="active">
                                    <i class="fas fa-caret-square-right"></i> PMTA
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'smtpCampaigns'}" active-class="active">
                                    <i class="fas fa-caret-square-right"></i> SMTP
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <router-link :to="{name: 'dashboard'}" active-class="active">
                            <i class="fas fa-chart-area"></i>
                            <span class="hide-menu">Dashboard</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'tags'}" active-class="active"><i
                                class="fas fa-code"></i><span class="hide-menu">Dynamic content</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'emailLists'}" active-class="active">
                            <i class="fas fa-at"></i><span class="hide-menu">Email Lists</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'messages'}" active-class="active"><i
                                class="fas fa-envelope"></i><span class="hide-menu">Messages</span></router-link>
                    </li>
                    <li>
                        <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                           aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                            <span class="hide-menu">PMTA</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li>
                                <router-link :to="{name: 'pmtaServers'}" active-class="active">
                                    <i class="ti-server"></i> Servers
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'pmtaRelayGroups'}" active-class="active">
                                    <i class="fas fa-sitemap"></i> Relay Groups
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'pmtaRelays'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Relays
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'pmtaEmailTests'}" active-class="active">
                                    <i class="fas fa-envelope"></i> Email Test
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'offersList'}" active-class="active">
                                    <i class="fas fa-road"></i> Offers
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                           aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                            <span class="hide-menu">SMTP</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li>
                                <router-link :to="{name: 'smtpServers'}" active-class="active">
                                    <i class="ti-server"></i> Servers
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'smtpRelayGroups'}" active-class="active">
                                    <i class="fas fa-sitemap"></i> Relay Groups
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'smtpRelays'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Relays
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'socksProxies'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Socks Proxies
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'links'}" active-class="active">
                                    <i class="fas fa-road"></i> Links
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'linkGroups'}" active-class="active">
                                    <i class="fas fa-sitemap"></i> Link Groups
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                           aria-expanded="false">
                            <i class="ti-stats-up"></i>
                            <span class="hide-menu">Reports</span>
                        </a>
                        <ul aria-expanded="false" class="collapse">
                            <li>
                                <router-link :to="{name: 'activityReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Activity
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'campaignReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Campaigns
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'emailListReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Email List
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'mailProviderReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Mail Services
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'messageReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Messages
                                </router-link>
                            </li>
                            <li v-if="this.$store.getters.isAdmin">
                                <router-link :to="{name: 'pmtaRelaysReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> PMTA Relays
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'pmtaRelaysMailServiceReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> PMTA Relays - Mail Service
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'pmtaTroubleReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> PMTA Troubles
                                </router-link>
                            </li>
                            <li v-if="this.$store.getters.isAdmin">
                                <router-link :to="{name: 'pmtaRelayIndicatorReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Relays Indicators
                                </router-link>
                            </li>
                            <li v-if="this.$store.getters.isAdmin">
                                <router-link :to="{name: 'pmtaRelayDeliverabilityReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> PMTA Deliverability
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'profitReport'}" active-class="active">
                                    <i class="far fa-list-alt"></i> Profit
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- ADMIN-->
                    <li v-if="this.$store.getters.isAdmin">
                        <router-link :to="{name: 'unsubscribers'}" active-class="active"><i
                                class="far fa-bell-slash"></i><span class="hide-menu">Unsubscribers</span>
                        </router-link>
                    </li>
                    <template v-if="this.$store.getters.isAdmin">
                        <li class="nav-small-cap">--- ADMIN</li>
                        <li>
                            <router-link :to="{name: 'categories'}" active-class="active">
                                <i class="ti-menu-alt"></i><span class="hide-menu">Categories</span>
                            </router-link>
                        </li>
                        <li>
                            <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                               aria-expanded="false">
                                <i class="fas fa-cogs"></i>
                                <span class="hide-menu">PMTA Configuration</span>
                            </a>
                            <ul aria-expanded="false" class="collapse">
                                <li>
                                    <router-link :to="{name: 'pmtaConfigs'}" active-class="active">
                                        <i class="fas fa-file"></i> Config Files
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'appliedPmtaConfigs'}" active-class="active">
                                        <i class="fas fa-paperclip"></i> Applied configs
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <router-link :to="{name: 'pmtaSpeeds'}" active-class="active">
                                <i class="fas fa-tachometer-alt"></i><span class="hide-menu">PMTA Speed</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'ReputationProviderList'}" active-class="active">
                                <i class="ti-target"></i><span class="hide-menu">Reputation Providers</span>
                            </router-link>
                        </li>
                        <li>
                            <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                               aria-expanded="false">
                                <i class="fas fa-poo"></i>
                                <span class="hide-menu">SpamTraps</span>
                            </a>
                            <ul aria-expanded="false" class="collapse">
                                <li>
                                    <router-link :to="{name: 'spamDomains'}" active-class="active">
                                        <i class="ti-menu-alt"></i> Domains
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'spamEmails'}" active-class="active">
                                        <i class="fas fa-at"></i> Emails
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'spamMxs'}" active-class="active">
                                        <i class="fas fa-server"></i> MXs
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a class="has-arrow waves-effect waves-dark" href="#" @click="toggleStatus($event)"
                               aria-expanded="false">
                                <i class="fas fa-wrench"></i>
                                <span class="hide-menu">Tools</span>
                            </a>
                            <ul aria-expanded="false" class="collapse">
                                <li>
                                    <router-link :to="{name: 'emailIdDecoder'}" active-class="active">
                                        <i class="fas fa-language"></i> Email ID Decoder
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'history'}" active-class="active">
                                        <i class="fas fa-book"></i> History
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'uuidDecoder'}" active-class="active">
                                        <i class="fas fa-language"></i> Uuid Decoder
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'uploadingLog'}" active-class="active">
                                        <i class="fas fa-book"></i> Uploading Log
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <router-link :to="{name: 'users'}" active-class="active">
                                <i class="fas fa-users"></i><span class="hide-menu">Users</span>
                            </router-link>
                        </li>
                    </template>
                </ul>
            </nav>
            <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
    </aside>
</template>

<script>
    export default {
        name: 'Sidebar',
        props: ['username'],
        methods:
            {
                toggleStatus(e) {
                    let targetElement = e.currentTarget;

                    if (targetElement.classList.contains('active')) {
                        targetElement.classList.remove('active');
                        targetElement.nextElementSibling.classList.remove('in');
                    } else {
                        targetElement.classList.add('active');
                        targetElement.nextElementSibling.classList.add('in');
                    }
                }
            }
    }
</script>

<style scoped>

</style>
